import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c(VMain,[_c('Loader'),_c('Snackbar'),(_vm.upgradeMode)?_c('UpgradeMode'):_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }